module.exports = __webpack_public_path__ + "img/iphone_3.35887e44.png";